import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiTenant, ListTenantsParams, tenantsService } from '../services';
import { TenantData } from '../../lib/mockData';
import { formatCpfCnpj } from '@/shared/utils/cnpj';

function mapApiTenant(item: ApiTenant): TenantData {
  const temTrialAtivo = (item.contracts ?? []).some((c) => c.status === 'TRIAL');
  const status: TenantData['status'] = !item.ativo ? 'suspenso' : temTrialAtivo ? 'trial' : 'ativo';
  return {
    id: item.id,
    nome: item.nomeFantasia || item.razaoSocial || '-',
    razaoSocial: item.razaoSocial || '-',
    nomeFantasia: item.nomeFantasia ?? undefined,
    documento: formatCpfCnpj(item.documento) || 'Sem documento',
    status,
    plano: [
      ...new Set(
        (item.contracts ?? []).map((c) => {
          const periodicityMap: Record<string, string> = {
            MONTHLY: 'Mensal',
            YEARLY: 'Anual',
            ONE_TIME: 'Avulso',
          };
          const label = c.product.periodicity ? (periodicityMap[c.product.periodicity] ?? '') : '';
          return label ? `${c.product.name} (${label})` : c.product.name;
        }),
      ),
    ],
    mrr: 0,
    dataInicio: '-',
    dataRenovacao: '-',
    usuarios: item._count.usuarios,
    processos: item._count.execucoes,
    storageUsadoGB: 0,
    ultimoAcesso: item.usuarios?.[0]?.ultimoAcesso ?? '-',
    healthScore: 0,
    pagamentoAtrasado: false,
    regiao: '-',
    adminNome: '-',
    adminEmail: '-',
    emTeste: false,
  };
}

export const fetchTenants = createAsyncThunk(
  'adminTenants/fetchTenants',
  async (params: ListTenantsParams | undefined, { rejectWithValue }) => {
    try {
      const response = await tenantsService.listTenants(params);
      return {
        tenants: response.data.map(mapApiTenant),
        pagination: response.pagination,
      };
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
